var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.document.createTitle'),"action":"create","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('document-form',{attrs:{"document":_vm.document,"product-templates":_vm.productTemplates}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }